import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pick } from 'lodash';

// import { Link } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  Button
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';

import PixelSetForm from './form';

import { listPixelSets, updatePixelSetSuccess, deletePixelSetSuccess } from '../../actions';
import { PixelSet } from '../../api'

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';


const mapStateToProps = state => ({ pixelSets: state.pixelSets, isLoading: state.loaders.pixelSets });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ listPixelSets, updatePixelSetSuccess, deletePixelSetSuccess }, dispatch)
};



const modalPropKeys = Object.keys(Modal.propTypes);

class EditPixelSetModal extends Component {
  
  constructor(props) {
    super(props);
    this.deletePixelSet = this.deletePixelSet.bind(this);
    this.state = {
      ...this.state,
      isDeleting: false,
    };
  }
  componentWillMount(nextProps) {
    // this.props.listPixelSets();
  }
  
  onSuccess(res) {
    const { updatePixelSetSuccess, toggle } = this.props; 
    updatePixelSetSuccess(res);
    toggle();
  }
  
  
  deletePixelSet(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    
    const { pixelId, pixelSets, deletePixelSetSuccess, toggle } = this.props;
    const pixelSet = pixelSets[pixelId];
    
    if (!window.confirm(`Are you sure?! ${pixelSet.links_num} links will be affected.`)){
      return;
    }
    const stopLoading = () => this.setState({isDeleting:false});
    
    this.setState({isDeleting:true});
    PixelSet.destroy({id:pixelSet.id}).then(deletePixelSetSuccess).then( ()=> {
      stopLoading();
      toggle();
    }, stopLoading);
  }
  
  render() {
    const { pixelId, toggle, updatePixelSetSuccess, pixelSets, ...otherProps } = this.props;
    const pixelSet = pixelSets[pixelId];
    const modalProps = pick(otherProps, modalPropKeys);
    
    return (pixelSet ? 
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle}>Edit Pixel List</ModalHeader>
        <ModalBody>
          <PixelSetForm initialValues={pixelSet} onSubmit={PixelSet.update} onSuccess={this.onSuccess.bind(this)} />
          <div className="text-center">
            or
            <Button color="link" onClick={this.deletePixelSet}><FA icon={faTrashAlt} /> delete this pixels list</Button>
          </div>
        </ModalBody>
      </Modal>
      : null);
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(EditPixelSetModal);


// WEBPACK FOOTER //
// ./src/components/PixelSets/editModal.js